import { safeGetItem, safeSetItem, safeRemoveItem } from '@/lib/browserStorage';

// Simple client-side auth helper using localStorage with temporary PIN
const AUTH_KEY = 'wsc.authenticated';
const PIN_KEY = 'wsc.pin';

export function isAuthenticated(): boolean {
  try {
    // Prefer cookie presence for cross-tab and server-side middleware checks.
    try {
      const cookieMatch = document.cookie.match(/(?:^|; )wsc.auth=([^;]+)/);
      if (cookieMatch && cookieMatch[1] === '1') {
        return true;
      }
    } catch (e) {
      // ignore cookie parsing errors
    }
    return safeGetItem(AUTH_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function loginWithPin(pin: string): boolean {
  // Temporary: accept only the default PIN unless overridden in localStorage
  const storedPin = getStoredPin();
  if (pin === storedPin) {
    try {
      safeSetItem(AUTH_KEY, '1');
      // Also set a cookie so server-side middleware can detect auth.
      // This is intentionally a non-httpOnly cookie because it's set from JS.
      // Expire in 7 days.
      try {
        const maxAge = 60 * 60 * 24 * 7; // 7 days
        document.cookie = `wsc.auth=1; path=/; max-age=${maxAge}; SameSite=Lax`;
      } catch (e) {
        // ignore cookie set errors
      }
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}

export function logout() {
  try {
    safeRemoveItem(AUTH_KEY);
    try {
      // Remove cookie by setting expiry in the past
      document.cookie = 'wsc.auth=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
    } catch (e) {
      // ignore
    }
  } catch (e) {
    // ignore
  }
}

export function getStoredPin(): string {
  try {
    const p = safeGetItem(PIN_KEY);
    if (p && p.trim().length > 0) {
      return p;
    }
  } catch (e) {
    // ignore
  }
  // default temporary PIN as requested by user
  return '4893';
}

export function setStoredPin(pin: string) {
  try {
    safeSetItem(PIN_KEY, pin);
  } catch (e) {
    // ignore
  }
}

export default {
  isAuthenticated,
  loginWithPin,
  logout,
  getStoredPin,
  setStoredPin,
};
